import common from './common.json';
import errors from './errors.json';
import Home from '../../pages/Form/Home/__i18n__/en.json';
import Header from '../../components/Header/__i18n__/en.json';
import FormNameModal from '../../components/Modal/FormName/__i18n__/en.json';
import Constructor from '../../pages/Form/Constructor/__i18n__/en.json';
import FormBuilder from '../../features/FormBuilder/__i18n__/en.json';
import EmailTest from '../../components/Modal/EmailTest/__i18n__/en.json';
import FieldTypeChanger from '../../components/FieldTypeChanger/__i18n__/en.json';
import FieldWrapper from '../../components/FieldWrapper/__i18n__/en.json';
import Options from '../../components/Options/__i18n__/en.json';
import ClientAndContactFieldInFormBuilder from '../../components/ClientAndContactFieldInFormBuilder/__i18n__/en.json';
import ModalConfig from '../../components/Modal/Config/__i18n__/en.json';
import Center from '../../components/Modal/Center/__i18n__/en.json';
import PreviewOnDevice from '../../components/Modal/PreviewOnDevice/__i18n__/en.json';
import variables from '../../components/TextEditor/VariablesButton/__i18n__/en.json';
import widgetHome from '../../pages/Widget/Home/__i18n__/en.json';
import widgetConstructor from '../../pages/Widget/Constructor/__i18n__/en.json';
import Orientation from '../../components/WidgetOrientation/__i18n__/en.json';
import WidgetConfig from '../../components/Modal/WidgetConfig/__i18n__/en.json';
import Groups from '../../components/Groups/__i18n__/en.json';
import FormSelector from '../../components/FormSelector/__i18n__/en.json';
import WidgetBuilder from '../../features/WidgetBuilder/__i18n__/en.json';
import MissingFieldsAlert from '../../components/MissingFieldsAlert/__i18n__/en.json';
import ActionsMenu from '../../components/ActionsMenu/__i18n__/en.json';
import CopyCode from '../../components/Modal/CopyCode/__i18n__/en.json';
import ContactSampleModal from '../../components/Modal/ContactSample/__i18n__/en.json';
import Drawer from '../../components/Drawer/__i18n__/en.json';

export default {
  common,
  errors,
  Home,
  Header,
  FormNameModal,
  Constructor,
  FormBuilder,
  EmailTest,
  FieldTypeChanger,
  FieldWrapper,
  Options,
  ClientAndContactFieldInFormBuilder,
  ModalConfig,
  Center,
  PreviewOnDevice,
  variables,
  widgetHome,
  widgetConstructor,
  Orientation,
  WidgetConfig,
  Groups,
  FormSelector,
  WidgetBuilder,
  MissingFieldsAlert,
  ActionsMenu,
  CopyCode,
  ContactSampleModal,
  Drawer,
};
